import React from 'react';
import { Table, Tag } from 'antd';
import { constructColumn, constructColumnFilterSearch, constructColumnFilterRadio } from 'utils/table/table';

const STATUS_SELECTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'cancelled', label: 'Cancelled' }
];

const statusColor = status => {
  if (status === 'active') return 'green';
  if (status === 'inactive') return 'orange';
  return 'red';
};

const constructColumns = productSelections => [
  {
    ...constructColumn('Host', 'hostName', { hasSorter: true, width: 240 }),
    ...constructColumnFilterSearch('hostName', 'Search host')
  },
  {
    ...constructColumn('Product', 'productName', { hasSorter: true, width: 220 }),
    ...(productSelections.length > 0 ? constructColumnFilterRadio('productName', productSelections) : {})
  },
  {
    ...constructColumn('Version', 'productVersion', { hasSorter: true, width: 100 })
  },
  {
    ...constructColumn('Status', 'status', { hasSorter: true, width: 120 }),
    ...constructColumnFilterRadio('status', STATUS_SELECTIONS),
    defaultFilteredValue: ['active'],
    render: status => <Tag color={statusColor(status)}>{status || '-'}</Tag>
  },
  {
    ...constructColumn('Started', 'startedAtLabel', { hasSorter: true, width: 140 })
  },
  {
    ...constructColumn('Ended', 'endedAtLabel', { hasSorter: true, width: 140 })
  }
];

const MarketplaceActivationsTable = ({ data, loading }) => {
  const productSelections = [];
  const seen = {};
  (data || []).forEach(row => {
    const name = row.productName || row.productCode;
    if (!name || seen[name]) return;
    seen[name] = true;
    productSelections.push({ value: name, label: name });
  });

  return (
    <Table
      rowKey="_id"
      columns={constructColumns(productSelections)}
      dataSource={data}
      loading={loading}
      scroll={{ x: 'max-content' }}
      pagination={{ pageSize: 20, showSizeChanger: true }}
    />
  );
};

export default MarketplaceActivationsTable;
